<template>
    <v-row justify="space-between"  >
        <v-col>
            <slot name="list">
                <!-- Here comes main panel -->
            </slot>
        </v-col>

        <v-divider vertical></v-divider>

        <template v-if="active">
            <v-col
                    v-if="!mode_phone"
                    cols="4"
            >
                <slot name="details_laptop">
                    <!-- here comes detailed panel on laptop : right -->
                    <!-- TODO: button to close panel -->
                </slot>
            </v-col>

            <v-bottom-sheet v-else v-model="is_active">
                <v-sheet class="text-center" style="height: 60vh; overflow-y: scroll">
                    <slot name="details_phone">
                        <!-- here comes detailed panel on phone : bottom overlay -->
                    </slot>
                </v-sheet>
            </v-bottom-sheet>

        </template>

    </v-row>

</template>

<script>
    export default {
        name: 'ListDetailsLayout',
        data: () => ({
            is_mobile: false,
            is_active: false,  // Panel is closed or opened
        }),
        props: {
            active: {
                type: Boolean,
                value: false
            }
        },
        watch: {
            is_active: function () {
                if (this.is_active === false) {
                    this.close_sheet();
                }
            },
            active: function(new_status){
                if(new_status){
                    this.is_active = true;
                }
            }
        },
        computed: {
            mode_phone() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        methods: {
            close_sheet(){
                console.log("click_outside");
                this.$emit('close_panel');
            }
        }
    }
</script>
